import { render, staticRenderFns } from "./devolucionesProdcuto.vue?vue&type=template&id=08bf3a6d&"
import script from "./devolucionesProdcuto.vue?vue&type=script&lang=ts&"
export * from "./devolucionesProdcuto.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VSpacer,VToolbar,VToolbarTitle})
